export default function CardsSection() {
  const getCardImage = (index: number) => {
    const images = [
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20a%20celebrity%20scandal%20breaking%20news%20with%20warm%20orange%20tones%2C%20magazine%20layout%20style%2C%20dramatic%20composition%2C%20bold%20graphic%20elements%2C%20news%20media%20aesthetic&width=800&height=600&seq=info-card-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20consumer%20product%20safety%20warning%20with%20warm%20amber%20tones%2C%20clean%20minimal%20design%2C%20product%20review%20style%2C%20informative%20graphics%2C%20consumer%20report%20aesthetic&width=800&height=600&seq=info-card-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20technology%20company%20internal%20documents%20leaked%20with%20warm%20coral%20tones%2C%20dark%20mood%2C%20investigative%20style%2C%20tech%20corporate%20drama%20vibe&width=800&height=600&seq=info-card-03&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20workplace%20harassment%20and%20office%20gossip%20with%20warm%20terracotta%20tones%2C%20abstract%20office%20elements%2C%20dramatic%20lighting%2C%20storytelling%20style&width=800&height=600&seq=info-card-04&orientation=landscape',
      'https://readdy.ai/api/search-image?query=An%20editorial%20illustration%20of%20live%20streaming%20platform%20controversy%20with%20warm%20orange%20and%20gold%20tones%2C%20vibrant%20social%20media%20elements%2C%20modern%20graphic%20style%2C%20digital%20drama%20aesthetic&width=800&height=600&seq=info-card-05&orientation=landscape',
    ];
    return images[index];
  };

  const CARDS = [
    {
      title: '知名艺人被曝税务问题，工作室连夜发声明回应',
      summary: '一条来自内部渠道的爆料引发全网震动，涉及金额据称高达千万级别。目前当事人工作室已紧急发布声明，但网友对此并不买账，事件仍在持续发酵中。',
      time: '3小时前',
      tag: '娱乐',
      hot: true,
    },
    {
      title: '某知名奶茶品牌被曝使用过期原料，多地质检介入',
      summary: '一位前员工通过每日爆料平台提交了大量内部照片，显示该品牌多家门店存在使用过期原料的情况。目前已有三个城市的市场监管部门介入调查。',
      time: '6小时前',
      tag: '消费',
      hot: true,
    },
    {
      title: '某大厂内部邮件曝光：年终奖大幅缩水引发员工抗议',
      summary: '一封据称来自某头部互联网公司的全员邮件在网络上疯传，邮件显示今年年终奖将比去年减少40%以上。多名员工向每日爆料证实了该邮件的真实性。',
      time: '8小时前',
      tag: '科技',
      hot: false,
    },
    {
      title: '某知名教育机构跑路前兆：教师工资已拖欠三个月',
      summary: '多位自称是该机构在职教师的网友联合爆料，称机构已连续三个月未发工资，同时大量学生预缴的学费去向不明。相关爆料已引起教育主管部门关注。',
      time: '12小时前',
      tag: '教育',
      hot: false,
    },
    {
      title: '某头部主播团队内部聊天记录流出：刷单流程全公开',
      summary: '一组据称来自某千万粉丝主播团队的内部聊天截图在平台上引发热议，记录了从选品、刷单到虚假宣传的完整操作流程，揭开直播带货行业灰色运作。',
      time: '1天前',
      tag: '直播',
      hot: true,
    },
  ];

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选爆料</h2>
            <p className="text-sm text-foreground-500 mt-2">每日爆料大赛优质参赛作品精选</p>
          </div>
          <a href="#" className="hidden sm:flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
            更多爆料 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((card, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={getCardImage(i)}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={card.title}
                />
                {card.hot && (
                  <div className="absolute top-3 right-3">
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                      <i className="ri-fire-line mr-0.5 text-[8px]"></i>热
                    </span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{card.time}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{card.summary}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-sm text-primary-500 font-medium flex items-center">
                    阅读详情 <i className="ri-arrow-right-s-line ml-0.5"></i>
                  </span>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line text-sm"></i>
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line text-sm"></i>
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line text-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}